import { render, staticRenderFns } from "./Guest.vue?vue&type=template&id=488c58c8&scoped=true&"
import script from "./Guest.vue?vue&type=script&lang=js&"
export * from "./Guest.vue?vue&type=script&lang=js&"
import style0 from "./Guest.vue?vue&type=style&index=0&id=488c58c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c58c8",
  null
  
)

export default component.exports